import WizardStep from "./WizardStep";

export default class ValidateRevenueStep extends WizardStep {
  type = WizardStep.TYPE_PROCESS;

  name = 'Validate Revenue';
  title = 'Validate Revenue';
  subtitle = "Compare revenues";
}